module.exports = __webpack_public_path__ + "img/Facheinheit_IuK.b72b904d.svg";